<template>
  <div>
    <base-material-card
      color="indigo"
      icon="mdi-account-cowboy-hat"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loading"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-spacer />
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="showAddrouter"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <router-link :to="{ name: 'router', params: { id: item.id }}">
            {{ item.name }}
          </router-link>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="error"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="removeRouterDialog(item.id)">
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>

    <v-dialog
      v-model="removeDialog"
      max-width="300"
      persistent
    >
      <v-card>
        <v-card-title>
          {{ $t('are-you-sure') }}

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="removeDialog = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="pb-6 pt-12 text-center">
          <v-btn
            class="mr-3"
            text
            @click="removeDialog = false"
          >
            {{ $t('No') }}
          </v-btn>

          <v-btn
            color="success"
            text
            @click="removeRouter"
          >
            {{ $t('Yes') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <router-select-dialog
      :show="addDialog"
      @change-add-dialog="addDialog = false"
      @add-router="addRouter"
    />
  </div>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const personsRespository = repositoryFactory.get('persons')
  const courierGroupsRespository = repositoryFactory.get('courierGroups')

  export default {
    name: 'GroupRouterList',
    components: {
      RouterSelectDialog: () => import('./RouterSelectDialog'),
    },
    props: {
      courierGroupId: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      removeDialog: false,
      removePersonId: null,
      addDialog: false,
    }),
    computed: {
      title: {
        get () {
          return this.$t('routers')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.groupRouter.name'),
            value: 'name',
          },
          {
            text: this.$t('tables.groupRouter.nip'),
            value: 'nip',
          },
          {
            text: this.$t('tables.groupRouter.cellPhone'),
            value: 'cellPhone',
          },
          {
            text: this.$t('tables.groupRouter.email'),
            value: 'email',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      this.getRouters()
    },
    methods: {
      getRouters () {
        var self = this
        self.loading = true
        personsRespository.getByCourierGroup(self.courierGroupId).then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      showAddrouter () {
        this.addDialog = true
      },
      addRouter (personId) {
        var self = this
        var data = {
          data: {
            courierGroupId: this.courierGroupId,
            personId: personId,
          },
        }
        self.loading = true
        courierGroupsRespository.addRouter(data).then(response => {
          if (!response.data.isValid) {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          } else {
            self.getRouters()
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      removeRouterDialog (personId) {
        this.removePersonId = personId
        this.removeDialog = true
      },
      removeRouter () {
        var self = this
        self.loading = true
        courierGroupsRespository.removeRouter(self.courierGroupId, self.removePersonId).then(response => {
          if (response.status !== 204) {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          } else {
            self.getRouters()
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
        this.removeDialog = false
      },
    },
  }
</script>
